import React from 'react';
import { CheckCircle2Icon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { trustItems } from '../data/content';
const icons = [LockIcon, CheckCircle2Icon, ShieldCheckIcon];
export function TrustRow({
  tone = 'light',
  items = trustItems
}: {
  tone?: 'light' | 'dark';
  items?: string[];
}) {
  return <ul className={`flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium ${tone === 'dark' ? 'text-cream/70' : 'text-ink-soft'}`} data-id="element-198" data-mp="2cp4l6ccy7f0c">
      {items.map(t => {
      const Icon = t.startsWith('Garantía') ? ShieldCheckIcon : t.startsWith('Pago') ? LockIcon : icons[1];
      return <li key={t} className="flex items-center gap-2" data-id="element-199" data-mp="1yy9hrfl7xq45">
            <Icon className={`h-4 w-4 ${tone === 'dark' ? 'text-terra-soft' : 'text-terra'}`} aria-hidden="true" data-id="element-200" data-mp="1tywmc6ga7apy" />
            {t}
          </li>;
    })}
    </ul>;
}